const LoaderSize = {
  Small: 'small',
  Normal: 'normal',
  Massive: 'massive',
};

export default LoaderSize;
